import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LOGGED_IN_USER_UPDATED } from "../../constants/sessionEvents";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "https://nodebackend.steamminds.org/api/v1",
  credentials: "include",
});

const AUTH_EXPIRED_MESSAGES = [
  "You are not authorized to access this route",
  "jwt must be provided",
];

const handleExpiredAuth = async () => {
  if (typeof window === "undefined") return;

  if (window.location.pathname.startsWith("/certificate/")) return;

  localStorage.removeItem("loggedInUser");
  window.dispatchEvent(new Event(LOGGED_IN_USER_UPDATED));

  try {
    const { resetApiCache } = await import("./resetApiCache");
    resetApiCache();
  } catch {
   
  }

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

const baseQueryWithAuthRedirect = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  const requestUrl = typeof args === "string" ? args : args?.url;
  if (requestUrl?.includes("/certificate/verify/")) {
    return result;
  }

  const message = result?.error?.data?.message;
  if (
    typeof message === "string" &&
    AUTH_EXPIRED_MESSAGES.includes(message)
  ) {
    handleExpiredAuth();
  }

  return result;
};

const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithAuthRedirect,
  tagTypes: [
    "Courses",
    "Enrollments",
    "Quizzes",
    "InstructorProfile",
    "Certificates",
  ],
  endpoints: () => ({}),
});

export default baseApi;